import { FC } from "react";
import BtButton from "../../../ts-components/bt-button/bt-button";
import moment from "moment";
import appState from "../../../state/AppStateContainer";
import HTMLParser from "../HTMLParser/HTMLParser";
import { ReactComponent as CommentIcon } from '../../../assets/svg/commentIcon.svg';

type Props = {
  openModal: () => void;
  hasContent: boolean;
  content: string;
  count: number;
  author: string;
  date: Date;
}

const ConversationButton : FC<Props> = ({ openModal, hasContent, content, count, author, date }) => {
  return (
    <div onClick={openModal} className="projectAreaCommentsContainer">
      <BtButton
        style={{ width: 'fit-content' }}
        color='white'
        size='xxs'
        leftIcon={<CommentIcon fill='var(--gray-500)' width='16px' height='16px' />}
      >
        {count}
      </BtButton>
      {hasContent && (
        <div className="latestComment">
          <div style={{ display: 'flex', gap: '8px' }}>
            <span className="author">{author}</span>
            <span className="date">{moment(date).locale(appState.state.language).fromNow()}</span>
          </div>
          <span style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden' }}>
            <HTMLParser data={content} />
          </span>
        </div>
      )}
    </div>
  )
};

export default ConversationButton;